import { Turbo } from "@hotwired/turbo-rails"
import { Modal } from "flowbite"

const modalEl = () => document.getElementById("confirm-modal")

let modal = null
function getModal() {
  const el = modalEl()
  if (!el) return null
  if (!modal) {
    modal = new Modal(el, { closable: false })
  }
  return modal
}

// Reset modal instance on Turbo page changes
document.addEventListener("turbo:before-render", () => { modal = null })

Turbo.config.forms.confirm = (message, _element) => {
  const el = modalEl()
  const messageEl = document.getElementById("confirm-modal-message")
  const acceptBtn = document.getElementById("confirm-modal-accept")
  const cancelBtn = document.getElementById("confirm-modal-cancel")
  const closeBtn = document.getElementById("confirm-modal-close")

  if (!el || !messageEl || !acceptBtn) {
    return Promise.resolve(confirm(message))
  }

  messageEl.textContent = message

  const m = getModal()

  return new Promise((resolve) => {
    let resolved = false

    function done(value) {
      if (resolved) return
      resolved = true
      acceptBtn.removeEventListener("click", accept)
      cancelBtn?.removeEventListener("click", cancel)
      closeBtn?.removeEventListener("click", cancel)
      m.hide()
      resolve(value)
    }

    function accept() { done(true) }
    function cancel() { done(false) }

    acceptBtn.addEventListener("click", accept)
    cancelBtn?.addEventListener("click", cancel)
    closeBtn?.addEventListener("click", cancel)

    m.show()
  })
}
